import type { CartaoFinanceiroTransferenciaProps } from "./types-cartao-financeiro-transferencia";
import { useCartaoFinanceiroTransferencia } from "./use-cartao-financeiro-transferencia";
import { CartaoFinanceiroTransferenciaView } from "./view-cartao-financeiro-transferencia";

export function CartaoFinanceiroTransferencia(props: CartaoFinanceiroTransferenciaProps) {
  const vm = useCartaoFinanceiroTransferencia(props);

  return <CartaoFinanceiroTransferenciaView {...vm} />;
}

export type * from "./types-cartao-financeiro-transferencia";
